import { createSlice } from "@reduxjs/toolkit";
import { checkFilterSelection } from "utils/consumerFilterUtils";

const initialState = {
    selectedStudyType: "home_use_test",
    selectedProducts: [],
    lookupProducts: [],
    lookupSelectedProducts: [],
    productSecondaryData: [],
    defaultProductSecondaryData: [],
    consumerFilters: {},
    allFiltersCrossStudy: [],
    parentIds: [],
    interpolationToggle: false,
    interpolationDetails: {},
    weightToggle: [],
    allDataMappingFilters: [],
    checkedVariables: {},
    correlationToggle: false,
    correlationMethod: "",
    correlationTargetVariable: "",
    correlationStudyTypeMethod: null,
};

export const matchNetStore = createSlice({
    name: "matchNetStore",
    initialState,
    reducers: {
        loadSelectedStudyTypeState: (state, action) => {
            state.selectedStudyType = action.payload;
        },
        loadSelectedProductsState: (state, action) => {
            state.selectedProducts = action.payload;
        },
        loadLookupProductsState: (state, action) => {
            state.lookupProducts = action.payload;
        },
        loadLookupSelectedProductsState: (state, action) => {
            state.lookupSelectedProducts = action.payload;
        },
        loadProductSecondaryDataState: (state, action) => {
            state.productSecondaryData = action.payload;
        },
        loadDefaultProductSecondaryDataState: (state, action) => {
            state.defaultProductSecondaryData = action.payload;
        },
        loadConsumerFiltersState: (state, action) => {
            state.consumerFilters = action.payload;
        },
        loadAllFiltersCrossStudyState: (state, action) => {
            state.allFiltersCrossStudy = action.payload;
        },
        loadParentIdsState: (state, action) => {
            state.parentIds = action.payload;
        },
        loadInterpolationToggleState: (state, action) => {
            state.interpolationToggle = action.payload;
        },
        loadInterpolationDetailsState: (state, action) => {
            state.interpolationDetails = action.payload;
        },
        loadWeightToggleState: (state, action) => {
            state.weightToggle = action.payload;
        },
        loadAllDataMappingFiltersState: (state, action) => {
            state.allDataMappingFilters = action.payload;
        },
        loadCheckedVariablesState: (state, action) => {
            state.checkedVariables = action.payload;
        },
        loadCorrelationToggleState: (state, action) => {
            state.correlationToggle = action.payload;
        },
        loadSelectedCorrelationMethodState: (state, action) => {
            state.correlationMethod = action.payload;
        },
        loadSelectedCorrelationTargetVariableState: (state, action) => {
            state.correlationTargetVariable = action.payload;
        },
        loadCorrelationStudyTypeMethodState: (state, action) => {
            state.correlationStudyTypeMethod = action.payload;
        },

        updateConsumerFilterValue: (state, action) => {
            const { studyTypeMethodTitle, key, value } = action.payload;
            if (key === "currentSelectedFilters") {
                const filterSelectionStatus = checkFilterSelection(value);
                state.consumerFilters[studyTypeMethodTitle]["filterSelectionStatus"] = filterSelectionStatus;
                const interpolationToggle = state.interpolationToggle;
                if (interpolationToggle) {
                    state.interpolationToggle = false;
                    state.interpolationDetails = {};
                }
            }

            state.consumerFilters[studyTypeMethodTitle][key] = value;
        },
        resetMatchNetStoreState: () => initialState,
    },
});

export const {
    loadSelectedStudyTypeState,
    loadSelectedProductsState,
    loadLookupProductsState,
    loadLookupSelectedProductsState,
    loadProductSecondaryDataState,
    loadDefaultProductSecondaryDataState,
    loadConsumerFiltersState,
    loadAllFiltersCrossStudyState,
    loadParentIdsState,
    loadWeightToggleState,
    loadAllDataMappingFiltersState,
    loadCheckedVariablesState,
    loadCorrelationToggleState,
    loadSelectedCorrelationMethodState,
    loadSelectedCorrelationTargetVariableState,
    loadCorrelationStudyTypeMethodState,
    loadInterpolationToggleState,
    loadInterpolationDetailsState,
    updateConsumerFilterValue,
    resetMatchNetStoreState,
} = matchNetStore.actions;

export default matchNetStore.reducer;
